import * as React                    from 'react';
import { useTranslation }            from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import DV                            from 'ts-data-validator';

import ConsultationBlock   from '../../components/consultationBlock';
import Preloader           from '../../components/containers/preloader';
import Meta                from '../../components/meta';
import { RenderBasicTabs } from '../../components/tabs/RenderBasicTabs';
import { useCommon }       from '../../providers/common';
import { useInformation }  from '../../providers/information';
import { useTab }          from '../../providers/tabs';

import { InformationContent } from './components';

const Information = function() {
  const history = useHistory();
  const match   = useRouteMatch<Record<'page' | 'urlKey', string>>();
  const { t }   = useTranslation();

  const { pages }   = useCommon() as any;
  const information = useInformation();
  const {
          registerTabsComponent,
          changeTab,
          ...tab
        }           = useTab() as any;

  const page            = React.useMemo(() => {
    return pages.find((page: any) => page.urlKey === match.params.page);
  }, [pages, match.params.page]);
  const meta            = React.useMemo(() => {
    // page.meta уже полностью нормализован на бэке (MetaBuilderService) —
    // тут только точечно переопределяем title/description/keywords конкретного
    // термина/вопроса, если открыт его детальный таб.
    const meta: any = { ...page.meta };

    if (DV.isString(match.params.urlKey)) {
      const categories = information.items;

      for (let category of categories) {
        let includes = false;

        for (let item of category.items) {
          if (item.urlKey === match.params.urlKey) {
            includes = true;

            meta.keywords    = item.meta.keywords;
            meta.description = item.meta.description;
            meta.title       = item.meta.title;

            break;
          }
        }

        if (includes) {
          break;
        }
      }
    }

    return meta;
  }, [information, page, match.params.urlKey]);
  const activeTab       = React.useMemo(() => {
    return information.isInterior ? 1 : tab.INFORMATION_TABS ?? 0;
  }, [information.isInterior, tab]);

  const handleChangeTab = React.useCallback((index: number) => {
    const template = pages.some((page: any) => page.template === 'terminology_interior') && index === 1
      ? 'terminology_interior'
      : 'terminology';
    const page     = pages.find((page: any) => page.template === template);

    if (page) {
      if (page.urlKey !== match.params.page) {
        information.changeTab(template);
        history.push(`/${page.urlKey}`);
      }
    }

    changeTab('INFORMATION_TABS', index);
  }, [changeTab, history, match.params.page, pages]);

  React.useEffect(() => {
    registerTabsComponent('INFORMATION_TABS');

    if (information.isInterior) {
      changeTab('INFORMATION_TABS', 1);
    }
  }, []);

  return (
    <>
      <div
        className={'page-content'}
        id={'information'}
      >
        <Meta {...meta} />
        <section className={'header'}>
          {DV.isString(match.params.urlKey)
            ? <div className={'page-title'}>{page.label}</div>
            : <h1>{page.label}</h1>
          }
        </section>
        <RenderBasicTabs
          active={activeTab}
          changeTab={handleChangeTab}
          forceTabs
          nav={[
            { label: t('entrance_doors') },
            { label: t('interior_doors') },
          ]}
        >
          <InformationContent />
          <InformationContent />
        </RenderBasicTabs>
        <ConsultationBlock />
      </div>
      {information.loading && <Preloader />}
    </>
  );
};
export default Information;